import { css } from '@emotion/core';
import { variables, aTag } from '@domain-group/fe-brary';

/* eslint-disable import/prefer-default-export */

var font = variables.font;
export var link = /*#__PURE__*/css(aTag, ";display:inline-block;width:50%;font-size:", font.smallFontSize, ";line-height:", font.smallLineHeight, ";font-weight:", font.headingFontWeight, ";margin:5px 0 10px;");